var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLympoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 193 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9619 24.4197H83.2433V0H77.2656V29.8887H95.9619V24.4197Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.223 9.98389C137.615 9.98389 135.517 10.9378 134.118 12.8456C132.846 11.0014 130.874 9.98389 128.394 9.98389C126.232 9.98389 124.515 10.747 123.371 12.2732V10.5562H117.583V29.8885H123.371V20.6039C123.371 17.1063 124.706 15.0713 126.995 15.0713C128.712 15.0713 129.666 16.2796 129.666 18.3146V29.8885H135.453V20.6039C135.453 17.1063 136.789 15.0713 139.078 15.0713C140.795 15.0713 141.749 16.2796 141.749 18.3146V29.8885H147.536V17.7422C147.472 12.9728 144.674 9.98389 140.223 9.98389Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.526 9.98389C159.301 9.98389 157.52 10.6834 156.248 12.0825V10.5562H150.461V39.9998H156.248V28.2351C157.52 29.5705 159.301 30.2701 161.526 30.2701C166.741 30.2701 170.366 26.0729 170.366 20.0952C170.366 14.2446 166.614 9.98389 161.526 9.98389ZM164.642 20.0952C164.642 23.0841 162.926 25.119 160.445 25.119C157.965 25.119 156.248 23.0205 156.248 20.0952C156.248 17.1699 157.965 15.0713 160.445 15.0713C162.862 15.0713 164.642 17.1699 164.642 20.0952Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.258 9.98389C176.534 9.98389 172.21 14.3718 172.21 20.1588C172.21 25.8821 176.471 30.2065 182.194 30.2065C187.917 30.2065 192.242 25.8185 192.242 20.0316C192.178 14.3082 187.917 9.98389 182.258 9.98389ZM186.391 20.1588C186.391 23.1476 184.738 25.1826 182.258 25.1826C179.714 25.1826 177.997 23.1477 177.997 20.0952C177.997 17.1063 179.65 15.0713 182.13 15.0713C184.674 15.0713 186.391 17.1699 186.391 20.1588Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.437 19.0777L100.35 10.2383H93.7361L102.194 24.9283L93.7997 39.9998H99.6503L116.121 10.5562H110.207L105.437 19.0777Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9412 20.9857L20.7312 0H0L17.3609 29.8887H27.7901L32.9412 20.9857Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.24 10.1113H40.5086L23.1477 40H43.8791L61.24 10.1113Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLympoWhite);
export default __webpack_public_path__ + "static/media/logo-lympo-white.35e9a109c236b06c57528bb2df84d744.svg";
export { ForwardRef as ReactComponent };